import React, { useContext, useEffect } from 'react';
import { Button, Form, Spinner, Table } from 'react-bootstrap';
import { MdFileCopy, MdEditSquare, MdDelete } from 'react-icons/md'
import { useNavigate } from 'react-router-dom';

import { get_slider_tag } from '../../../../Controller/actions';
import { NewContext } from '../../../../Context/NewContext';
import PaginationCmp from '../../../../Components/Pagination/PaginationCmp';
import { Header } from '../../../../Components/Header';
import { THead } from '../../../../Components/Table';

import './slidertags.css';

export const SliderTags = ({ title }) => {
    const navigate = useNavigate();
    const { filterDropdown, currentTableData, setCurrentTableData, currentPage, setCurrentPage, totalPage, setTotalPage, perPage, setPerPage, isLoading, setIsLoading, confirmationModalShow, setConfirmationModalShow, deleteUpdateTag, setDeleteUpdateItem, search, setDeleteUpdateYes, checkedValues, handleCopyData, handleCheckboxChange } = useContext(NewContext);
    const simpleFields = ["Id", "Name"];
    const dropdownFields = ["Active"];
    const totalFields = simpleFields.length + dropdownFields.length + 2;

    let handleSwitch = (e) => {
        setDeleteUpdateYes("updateslidertag");
        setDeleteUpdateItem({ id: e.target.id, [e.target.name]: !e.target.checked ? false : true });
        setConfirmationModalShow(!confirmationModalShow)
    };

    const getSliderTagsData = async (_currentPage = 1) => {
        setIsLoading(true);
        try {
            const getSliderTags = await get_slider_tag(_currentPage, perPage, search, filterDropdown);
            if (getSliderTags) {
                const { status, data, currentPage, perPage, totalPage } = getSliderTags;
                if (status) {
                    // console.log(data, '----data');
                    setCurrentTableData(data);
                    // setCurrentPage(currentPage);
                    // setPerPage(perPage);
                    // setTotalPage(totalPage);
                } else {
                    // toast.error(message);
                    setCurrentTableData([]);
                }
            }
            setIsLoading(false);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getSliderTagsData(currentPage);
    }, [deleteUpdateTag, search, filterDropdown]);

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`
    }, []);

    return (
        <div className='table-header-main ms-auto p-3'>
            <Header title={`Slider Tags`} previewLink={`/preview`} addLink={`/slidertagsform`} deleteUpdateTag={"alldeleteslidertags"} />
            <Table striped bordered hover responsive className='mb-3'>
                <THead
                    simpleFields={simpleFields}
                    dropdownFields={dropdownFields}
                />
                <tbody>
                    {
                        isLoading ?
                            <tr>
                                <td colSpan={totalFields} className='py-5'>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <Spinner animation="border" />
                                    </div>
                                </td>
                            </tr>
                            : currentTableData.length === 0 ?
                                <tr>
                                    <td colSpan={totalFields} className='py-5 bg-light'>
                                        <div className="d-flex justify-content-center align-items-center">
                                            No Data Found
                                        </div>
                                    </td>
                                </tr>
                                : currentTableData.map((_ele, i) => (
                                    <tr key={i} className="align-middle">
                                        <td>
                                            <Form.Check
                                                type={'checkbox'}
                                                id={`tag-${_ele._id}`}
                                                value={`${_ele._id}`}
                                                checked={checkedValues.includes(`${_ele._id}`)}
                                                onChange={() => handleCheckboxChange(`${_ele._id}`)}
                                            />
                                        </td>
                                        {/* perPage * (currentPage - 1) +  */}
                                        <td>{(i + 1)}</td>
                                        <td>{_ele.name}</td>
                                        {/* <td><img className='table-preview_img' src={`${_ele.preview ? `${baseURL}/${_ele.preview}` : `../../../assets/images/no-image.png`}`} alt={_ele.name} /></td> */}
                                        {/* <td>{_ele.userHit}</td> */}
                                        {
                                            ["isActive"].map((_is_ele, i) => (
                                                <td key={i}>
                                                    {/* <Badge bg={_is_ele ? "success" : "danger"} className="fw-normal">
                                                        {_is_ele ? `On` : `Off`}
                                                    </Badge> */}
                                                    <Form.Check type="switch" id={_ele._id} name={_is_ele} onChange={handleSwitch} checked={_ele[_is_ele]} role="button" />
                                                </td>
                                            ))
                                        }
                                        <td>
                                            <div className='d-flex'>
                                                {/* <TooltipCmp placement={`top`} tooltipText={copyText}> */}
                                                <Button className='px-2 me-2' variant="info" onClick={() => handleCopyData(_ele)}>
                                                    <MdFileCopy color='black' size={"18px"} />
                                                </Button>
                                                {/* </TooltipCmp> */}

                                                {/* <TooltipCmp placement={`top`} tooltipText={`Edit`}> */}
                                                <Button className='px-2 me-2' variant="warning" onClick={() => navigate(`/slidertagsform`, { state: _ele })}>
                                                    <MdEditSquare color='black' size={"18px"} />
                                                </Button>
                                                {/* </TooltipCmp> */}

                                                {/* <TooltipCmp placement={`top`} tooltipText={`Delete`}> */}
                                                <Button className='px-2 me-2' variant="danger" onClick={() => { setDeleteUpdateYes("deleteslidertag"); setDeleteUpdateItem({ id: _ele._id, name: _ele.name }); setConfirmationModalShow(!confirmationModalShow) }}>
                                                    <MdDelete color='black' size={"18px"} />
                                                </Button>
                                                {/* </TooltipCmp> */}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                    }
                </tbody>
            </Table>
            <div className={`table-pagination d-flex justify-content-end ${currentTableData.length > 15 ? 'd-block' : 'd-none'}`}>
                <PaginationCmp
                    currentPage={currentPage}
                    totalPage={totalPage}
                    getData={getSliderTagsData}
                />
            </div>
        </div>
    )
};

SliderTags.defaultProps = {
    title: "Slider Tags"
};

export default SliderTags;
